import(/* webpackMode: "eager" */ "/app/apps/solars/app/[locale]/not-found.tsx");
